/* KOR-E footer accordion — extracted from sections/footer.liquid (Batch AQ). Liquid-free. */

      (function () {
        var accordion = document.querySelector('.kore-mobile-footer-accordion');
        if (!accordion) return;
        accordion.querySelectorAll('.kore-mobile-footer-accordion__button').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var expanded = this.getAttribute('aria-expanded') === 'true';
            var panelId  = this.getAttribute('aria-controls');
            var panel    = document.getElementById(panelId);
            if (!panel) return;
            this.setAttribute('aria-expanded', String(!expanded));
            if (expanded) {
              panel.setAttribute('hidden', '');
            } else {
              panel.removeAttribute('hidden');
            }
          });
        });
      })();
    
